var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigcontact2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6468)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.9658,
    y1: 120.093,
    x2: 17.9658,
    y2: -21.4222,
    stroke: "url(#paint0_linear_75_6468)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.9658,
    y1: 120.093,
    x2: 52.9658,
    y2: -21.4222,
    stroke: "url(#paint1_linear_75_6468)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.9658,
    y1: 120.093,
    x2: 88.9658,
    y2: -21.4222,
    stroke: "url(#paint2_linear_75_6468)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.966,
    y1: 120.093,
    x2: 124.966,
    y2: -21.4222,
    stroke: "url(#paint3_linear_75_6468)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.966,
    y1: 120.093,
    x2: 160.966,
    y2: -21.4222,
    stroke: "url(#paint4_linear_75_6468)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.966,
    y1: 120.093,
    x2: 195.966,
    y2: -21.4222,
    stroke: "url(#paint5_linear_75_6468)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.966,
    y1: 120.093,
    x2: 231.966,
    y2: -21.4222,
    stroke: "url(#paint6_linear_75_6468)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 18.954,
    x2: 258.387,
    y2: 18.954,
    stroke: "url(#paint7_linear_75_6468)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 77.954,
    x2: 258.387,
    y2: 77.954,
    stroke: "url(#paint8_linear_75_6468)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 47.954,
    x2: 258.387,
    y2: 47.954,
    stroke: "url(#paint9_linear_75_6468)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "url(#paint10_linear_75_6468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 52.75C58.9557 52.75 57.9542 53.1648 57.2158 53.9033C56.4773 54.6417 56.0625 55.6432 56.0625 56.6875C56.0625 57.7318 56.4773 58.7333 57.2158 59.4717C57.9542 60.2102 58.9557 60.625 60 60.625C61.0443 60.625 62.0458 60.2102 62.7842 59.4717C63.5227 58.7333 63.9375 57.7318 63.9375 56.6875C63.9375 55.6432 63.5227 54.6417 62.7842 53.9033C62.0458 53.1648 61.0443 52.75 60 52.75Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.625 48.1562C41.625 46.3433 43.095 44.875 44.9062 44.875H75.0938C76.905 44.875 78.375 46.345 78.375 48.1562V65.2188C78.375 67.0317 76.905 68.5 75.0938 68.5H44.9062C44.4754 68.5 44.0487 68.4151 43.6506 68.2502C43.2525 68.0853 42.8907 67.8436 42.5861 67.5389C42.2814 67.2343 42.0397 66.8725 41.8748 66.4744C41.7099 66.0763 41.625 65.6497 41.625 65.2188V48.1562ZM53.4375 56.6875C53.4375 54.947 54.1289 53.2778 55.3596 52.0471C56.5903 50.8164 58.2595 50.125 60 50.125C61.7405 50.125 63.4097 50.8164 64.6404 52.0471C65.8711 53.2778 66.5625 54.947 66.5625 56.6875C66.5625 58.428 65.8711 60.0972 64.6404 61.3279C63.4097 62.5586 61.7405 63.25 60 63.25C58.2595 63.25 56.5903 62.5586 55.3596 61.3279C54.1289 60.0972 53.4375 58.428 53.4375 56.6875ZM71.8125 55.375C71.4644 55.375 71.1306 55.5133 70.8844 55.7594C70.6383 56.0056 70.5 56.3394 70.5 56.6875V56.7015C70.5 57.426 71.088 58.014 71.8125 58.014H71.8265C72.1746 58.014 72.5084 57.8757 72.7546 57.6296C73.0007 57.3834 73.139 57.0496 73.139 56.7015V56.6875C73.139 56.3394 73.0007 56.0056 72.7546 55.7594C72.5084 55.5133 72.1746 55.375 71.8265 55.375H71.8125ZM46.875 56.6875C46.875 56.3394 47.0133 56.0056 47.2594 55.7594C47.5056 55.5133 47.8394 55.375 48.1875 55.375H48.2015C48.5496 55.375 48.8834 55.5133 49.1296 55.7594C49.3757 56.0056 49.514 56.3394 49.514 56.6875V56.7015C49.514 57.0496 49.3757 57.3834 49.1296 57.6296C48.8834 57.8757 48.5496 58.014 48.2015 58.014H48.1875C47.8394 58.014 47.5056 57.8757 47.2594 57.6296C47.0133 57.3834 46.875 57.0496 46.875 56.7015V56.6875Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9375 71.125C42.5894 71.125 42.2556 71.2633 42.0094 71.5094C41.7633 71.7556 41.625 72.0894 41.625 72.4375C41.625 72.7856 41.7633 73.1194 42.0094 73.3656C42.2556 73.6117 42.5894 73.75 42.9375 73.75C52.3875 73.75 61.54 75.0135 70.2375 77.3813C72.32 77.9483 74.4375 76.4047 74.4375 74.1962V72.4375C74.4375 72.0894 74.2992 71.7556 74.0531 71.5094C73.8069 71.2633 73.4731 71.125 73.125 71.125H42.9375Z",
    fill: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "url(#paint11_linear_75_6468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3934 212.848C28.6348 212.848 31.5591 210.616 31.5591 207.022V206.732H28.9027V207.022C28.9027 209.321 27.4517 210.527 24.4158 210.527C20.911 210.527 19.2145 208.875 19.2145 205.147C19.2145 201.419 20.911 199.745 24.4158 199.745C27.4517 199.745 28.9027 200.972 28.9027 203.249V203.562H31.5591V203.249C31.5591 199.678 28.6125 197.445 24.3934 197.445C19.7503 197.445 16.6697 200.481 16.6697 205.147C16.6697 209.812 19.7503 212.848 24.3934 212.848ZM36.5943 212.848C39.1168 212.848 40.8803 211.732 41.4607 209.857H41.617V212.625H43.8269V205.883C43.8269 203.227 42.242 201.307 38.715 201.307C35.188 201.307 33.0896 203.205 33.0896 205.727V205.817H35.4782V205.727C35.4782 204.098 36.4827 203.428 38.5364 203.428C40.6571 203.428 41.4607 204.075 41.4607 205.906V206.553L36.4157 207.089C34.2281 207.334 32.8441 208.227 32.8441 209.946C32.8441 211.777 34.295 212.848 36.5943 212.848ZM35.2549 209.79C35.2549 208.919 35.8577 208.629 37.1077 208.473L41.4607 207.982C41.4607 210.169 39.7642 211.107 37.2417 211.107C35.8577 211.107 35.2549 210.683 35.2549 209.79ZM51.2249 212.848C54.3501 212.848 56.4038 211.62 56.4038 209.544C56.4038 207.714 55.1984 206.821 52.5643 206.486L49.9971 206.129C48.3229 205.906 47.8765 205.593 47.8765 204.723C47.8765 203.673 48.5908 203.227 50.6222 203.227C53.0777 203.227 53.7474 203.919 53.7474 205.236V205.37H56.136V205.303C56.136 202.669 54.0822 201.307 50.6892 201.307C47.2737 201.307 45.5102 202.691 45.5102 204.633C45.5102 206.486 46.7826 207.379 48.881 207.647L51.9169 208.049C53.5019 208.272 54.0376 208.562 54.0376 209.477C54.0376 210.46 53.3902 210.906 51.2249 210.906C48.9033 210.906 48.0327 210.437 48.0327 208.986V208.808H45.6219V208.875C45.6219 211.442 47.6532 212.848 51.2249 212.848ZM60.5542 212.625V207.245C60.5542 204.901 61.4917 203.473 64.1258 203.473C66.4251 203.473 67.4296 204.366 67.4296 206.598V212.625H69.8182V206.017C69.8182 203.316 68.3225 201.307 65.2643 201.307C62.4293 201.307 61.0676 203.048 60.6881 204.924H60.5542V197.669H58.1433V212.625H60.5542ZM80.6898 212.848C83.19 212.848 84.8196 211.643 85.2883 209.433H85.4446V212.625H87.6546V197.669H85.2437V204.544H85.1097C84.6633 202.669 83.1677 201.307 80.5335 201.307C77.1628 201.307 75.243 203.629 75.243 207.089C75.243 210.504 77.1851 212.848 80.6898 212.848ZM77.6762 207.089C77.6762 204.41 79.0602 203.495 81.3818 203.495C83.8597 203.495 85.2437 204.656 85.2437 207.022V207.201C85.2437 209.522 83.7927 210.638 81.4265 210.638C79.0379 210.638 77.6762 209.745 77.6762 207.089ZM95.4645 212.848C98.7683 212.848 101.09 211.219 101.09 208.852V208.652H98.679V208.83C98.679 210.147 97.7191 210.906 95.3975 210.906C92.8303 210.906 91.7812 209.768 91.6919 207.625H101.112C101.179 207.29 101.201 206.977 101.201 206.575C101.201 203.205 98.8575 201.307 95.4198 201.307C91.8035 201.307 89.4373 203.629 89.4373 207.089C89.4373 210.795 91.8258 212.848 95.4645 212.848ZM95.3752 203.205C97.7414 203.205 98.9245 204.187 98.9245 206.241V206.285H91.7142C91.8481 204.299 92.9196 203.205 95.3752 203.205ZM105.418 216.42V209.5H105.507C105.954 211.531 107.561 212.848 110.061 212.848C113.521 212.848 115.419 210.527 115.419 207.089C115.419 203.651 113.477 201.307 110.039 201.307C107.427 201.307 105.865 202.557 105.418 204.611H105.217V201.53H103.007V216.42H105.418ZM105.418 207.267V207.067C105.418 204.678 106.802 203.517 109.28 203.517C111.602 203.517 113.008 204.41 113.008 207.089C113.008 209.745 111.624 210.661 109.235 210.661C106.869 210.661 105.418 209.544 105.418 207.267ZM122.76 212.848C126.465 212.848 128.943 210.504 128.943 207.089C128.943 203.629 126.465 201.307 122.76 201.307C119.077 201.307 116.599 203.629 116.599 207.089C116.599 210.504 119.077 212.848 122.76 212.848ZM122.76 210.705C120.081 210.705 118.965 209.433 118.965 207.089C118.965 204.723 120.081 203.428 122.76 203.428C125.461 203.428 126.577 204.723 126.577 207.089C126.577 209.433 125.461 210.705 122.76 210.705ZM135.939 212.848C139.064 212.848 141.118 211.62 141.118 209.544C141.118 207.714 139.912 206.821 137.278 206.486L134.711 206.129C133.037 205.906 132.59 205.593 132.59 204.723C132.59 203.673 133.305 203.227 135.336 203.227C137.792 203.227 138.461 203.919 138.461 205.236V205.37H140.85V205.303C140.85 202.669 138.796 201.307 135.403 201.307C131.988 201.307 130.224 202.691 130.224 204.633C130.224 206.486 131.496 207.379 133.595 207.647L136.631 208.049C138.216 208.272 138.751 208.562 138.751 209.477C138.751 210.46 138.104 210.906 135.939 210.906C133.617 210.906 132.747 210.437 132.747 208.986V208.808H130.336V208.875C130.336 211.442 132.367 212.848 135.939 212.848ZM145.268 200.236V197.669H142.857V200.236H145.268ZM145.268 212.625V201.53H142.857V212.625H145.268ZM154.778 212.625V210.46H152.769C151.385 210.46 150.76 210.103 150.76 208.741V203.54H154.778V201.53H150.76V199.097H148.371V201.53H146.496V203.54H148.371V208.875C148.371 211.576 149.844 212.625 152.233 212.625H154.778Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6468",
    x1: 18.4658,
    y1: -1.34432,
    x2: 18.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6468",
    x1: 53.4658,
    y1: -1.34432,
    x2: 53.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_6468",
    x1: 89.4658,
    y1: -1.34432,
    x2: 89.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_6468",
    x1: 125.466,
    y1: -1.34432,
    x2: 125.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_6468",
    x1: 161.466,
    y1: -1.34432,
    x2: 161.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_6468",
    x1: 196.466,
    y1: -1.34432,
    x2: 196.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_6468",
    x1: 232.466,
    y1: -1.34432,
    x2: 232.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_6468",
    x1: 0,
    y1: 19.454,
    x2: 255.154,
    y2: 19.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_6468",
    x1: 0,
    y1: 78.454,
    x2: 255.154,
    y2: 78.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_75_6468",
    x1: 0,
    y1: 48.454,
    x2: 255.154,
    y2: 48.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_75_6468",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_75_6468",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6468"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcontact2);
export default __webpack_public_path__ + "static/media/bigcontact2.6611f2cbb4d3746ac80024a23c3f1e3a.svg";
export { ForwardRef as ReactComponent };